import _extends from "@babel/runtime-corejs3/helpers/extends";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = _Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useRef, forwardRef, useState, useEffect } from 'react';
import Modal from '../modal';
import { getCompProps } from '../_utils';
import ConfigContext from '../config-provider/ConfigContext';
import Cropper from './cropper';
import OperationBar from './operation-bar';
import classNames from 'classnames';

var InternalImageCropper = function InternalImageCropper(props, forwardedRef) {
  var _useState = useState(props.image || ''),
      _useState2 = _slicedToArray(_useState, 2),
      cropperSrc = _useState2[0],
      setCropperSrc = _useState2[1];

  var innerRef = useRef(null);
  var cropperRef = forwardedRef || innerRef;

  var _React$useContext = React.useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      pkgPrefixCls = _React$useContext.prefixCls,
      userDefaultProps = _React$useContext.compDefaultProps;

  var _a = getCompProps('ImageCropper', userDefaultProps, props),
      customPrefixcls = _a.prefixCls,
      containerWidth = _a.containerWidth,
      containerHeight = _a.containerHeight,
      title = _a.title,
      visible = _a.visible,
      onClose = _a.onClose,
      onCropSuccess = _a.onCropSuccess,
      onCropFailed = _a.onCropFailed,
      dragMode = _a.dragMode,
      viewMode = _a.viewMode,
      aspectRatio = _a.aspectRatio,
      modal = _a.modal,
      okText = _a.okText,
      okBtn = _a.okBtn,
      _a$image = _a.image,
      image = _a$image === void 0 ? '' : _a$image,
      zoomOnWheel = _a.zoomOnWheel,
      imageMaxSize = _a.imageMaxSize,
      cropBoxMovable = _a.cropBoxMovable,
      customComponents = _a.customComponents,
      showDeaultToolbar = _a.showDeaultToolbar,
      restProps = __rest(_a, ["prefixCls", "containerWidth", "containerHeight", "title", "visible", "onClose", "onCropSuccess", "onCropFailed", "dragMode", "viewMode", "aspectRatio", "modal", "okText", "okBtn", "image", "zoomOnWheel", "imageMaxSize", "cropBoxMovable", "customComponents", "showDeaultToolbar"]);

  var prefixCls = getPrefixCls(pkgPrefixCls, 'image-cropper', customPrefixcls);

  var handleOkClick = function handleOkClick() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var imgFile;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return cropperRef.current.getImage();

            case 2:
              imgFile = _context.sent;
              imgFile ? onCropSuccess === null || onCropSuccess === void 0 ? void 0 : onCropSuccess(imgFile) : onCropFailed === null || onCropFailed === void 0 ? void 0 : onCropFailed(imgFile);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  };

  var handleRotate = function handleRotate() {
    var _a;

    (_a = cropperRef.current) === null || _a === void 0 ? void 0 : _a.rotate();
  };

  var handleRevert = function handleRevert() {
    var _a;

    (_a = cropperRef.current) === null || _a === void 0 ? void 0 : _a.reset();
  };

  var handleZoom = function handleZoom(num) {
    var _a;

    (_a = cropperRef.current) === null || _a === void 0 ? void 0 : _a.zoom(num);
  };

  var handleReplace = function handleReplace(src) {
    setCropperSrc(src);
  };

  useEffect(function () {
    setCropperSrc(image);
  }, [image]);
  var CropperNode = /*#__PURE__*/React.createElement(Cropper, {
    className: "".concat(prefixCls, "-container"),
    dragMode: dragMode,
    viewMode: viewMode,
    aspectRatio: aspectRatio,
    modal: modal,
    zoomOnWheel: zoomOnWheel,
    cropBoxMovable: cropBoxMovable,
    imgSrc: cropperSrc,
    ref: cropperRef
  });
  var OperationBarNode = /*#__PURE__*/React.createElement(OperationBar, {
    className: "".concat(prefixCls, "-bar-container"),
    btnClassName: "".concat(prefixCls, "-btn-container"),
    imageMaxSize: imageMaxSize,
    onClick: handleOkClick,
    onRotate: handleRotate,
    onRevert: handleRevert,
    onZoom: handleZoom,
    onReplace: handleReplace,
    okText: okText,
    okBtn: okBtn,
    customComponents: customComponents,
    getCropper: cropperRef,
    showDeaultToolbar: showDeaultToolbar
  });
  return /*#__PURE__*/React.createElement(Modal, _extends({
    className: classNames("".concat(prefixCls, "-modal-container")),
    bodyClassName: classNames("".concat(prefixCls, "-modal-body-container")),
    width: containerWidth,
    height: containerHeight,
    body: CropperNode,
    footer: OperationBarNode,
    visible: visible,
    title: title,
    onCancel: onClose
  }, restProps));
};

var ImageCropper = /*#__PURE__*/forwardRef(InternalImageCropper);
ImageCropper.displayName = 'ImageCropper';
export default ImageCropper;